import { useState } from 'react';
import { Box, Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useAuth } from '../../shared/contexts';

export const EstrategiaVendas = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const { getUser } = useAuth();
    const userName = getUser().data.name; // Pega o nome do usuário dinamicamente

    const handleToggleDialog = () => {
        setOpenDialog((prev) => !prev);
    };

    const instrucoes = [
        {
            titulo: "Guia de Vendas - Sistema de Internet via Bilhete",
            descricao: "Siga este guia para abordar clientes e apresentar o sistema de maneira clara e eficaz.",
        },
        {
            titulo: "1ª Mensagem – Abordagem inicial (WhatsApp)",
            descricao: `💬 Mensagem:
    Olá, tudo bem? Meu nome é ${userName}, e trabalho com soluções para ajudar negócios como o seu a aumentar a receita de forma simples e prática. Eu gostaria de te mostrar uma novidade que pode transformar o Wi-Fi do seu estabelecimento em uma fonte de renda. Você gostaria de saber mais?`,
        },
        {
            titulo: "2ª Mensagem – Explicação Inicial",
            descricao: `💬 Mensagem:
    Ótimo! Vou te explicar como funciona:
    Nosso sistema permite que você venda acesso à internet para os seus visitantes, usando bilhetes com senhas exclusivas. É simples: você controla quem usa e por quanto tempo, e ainda pode ganhar uma boa renda extra com isso.
    
    Por exemplo:
    Se você vender 20 bilhetes a R$ 5,00 em um dia, já terá R$ 100,00.
    
    Posso te mostrar mais detalhes?`,
        },
        {
            titulo: "3ª Mensagem – Explicação Detalhada",
            descricao: `💬 Mensagem:
    Claro! Vou te explicar de forma bem simples:
    
    1️⃣ Controle total: Você escolhe quanto tempo ou dados cada bilhete vale.
    2️⃣ Sem complicação: O sistema organiza tudo e dá relatórios com suas vendas.
    3️⃣ Sem risco: Você só paga pelo sistema quando vender, sem custo fixo.
    
    Isso significa que você não precisa investir nada sem retorno.
    
    Seus clientes também saem felizes porque conseguem usar o Wi-Fi com facilidade e segurança.
    
    Podemos agendar uma ligação rápida ou uma demonstração para você ver como funciona?`,
        },
        {
            titulo: "Dúvidas Frequentes dos Clientes",
            descricao: `💬 Mensagens:
    
    ❓ O que acontece se eu não vender?
    ➡️ Não há custo se você não realizar vendas.
    
    ❓ O sistema é complicado?
    ➡️ Não! Ele é fácil de usar e acompanha manuais de instrução.
    
    ❓ Preciso de conhecimento técnico para instalar?
    ➡️ Não. Nós oferecemos suporte total para configuração.`,
        },
        {
            titulo: "Teste Inicial – Passo a Passo",
            descricao: `🎯 Passos para começar:
    1️⃣ Ative o sistema: Configuramos tudo para você.
    2️⃣ Crie bilhetes de teste: Teste com um grupo pequeno de clientes.
    3️⃣ Analise as vendas: Ajuste os valores e períodos conforme os resultados.
    4️⃣ Expanda: Quando se sentir seguro, ofereça os bilhetes para mais clientes.`,
        },
        {
            titulo: "Principais Vantagens",
            descricao: `✅ Renda extra garantida com a venda de bilhetes.
    ✅ Controle de acesso à internet de forma simples.
    ✅ Sem mensalidade fixa – você só paga se vender.
    ✅ Relatórios diários, semanais e mensais para monitorar suas vendas.`,
        },
        {
            titulo: "Garantias e Suporte",
            descricao: `📞 Garantimos suporte técnico e comercial completo.
    📅 Satisfação garantida ou reembolso nos primeiros 30 dias.
    Entre em contato para mais informações!`,
        },
    ];





    return (
        <Box width="100%" display="flex" flexDirection="column" alignItems="center" padding={2}>
            {/* Botão para abrir o dialog */}
            <Button
                variant="contained"
                onClick={handleToggleDialog}
                sx={{ marginBottom: 2 }}
            >
                Instruções de vendas
            </Button>

            {/* Dialog que exibe o conteúdo */}
            <Dialog open={openDialog} onClose={handleToggleDialog} fullWidth maxWidth="md">
                <DialogTitle>Instruções de Venda</DialogTitle>
                <DialogContent>
                    {instrucoes.map((instrucao, index) => (
                        <Card key={index} sx={{ marginBottom: 2 }}>
                            <CardContent>
                                <Typography variant="h6" component="div" gutterBottom>
                                    {instrucao.titulo}
                                </Typography>
                                <Typography variant="body1">
                                    {instrucao.descricao}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </DialogContent>
                <Box display="flex" justifyContent="center" padding={2}>
                    <Button variant="contained" onClick={handleToggleDialog}>
                        Fechar
                    </Button>
                </Box>
            </Dialog>
        </Box>
    );
};
